import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ExperimentContext from '../experiment/provider';
import Experiment from '../experiment';

const getParentNode = props => {
  try {
    const isElementExperiment =
      props?.return?.elementType?.name === Experiment?.name;

    return isElementExperiment
      ? props.return?.memoizedProps?.name
      : getParentNode(props.return) || null;
  } catch {
    return null;
  }
};

export default class When extends PureComponent {
  static contextType = ExperimentContext;

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
      PropTypes.elementType
    ]).isRequired,
    bucket: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    assignedBucketFunc: PropTypes.func,
    onMount: PropTypes.func
  };

  static defaultProps = {
    onMount: null,
    assignedBucketFunc: null
  };

  state = {
    parent: null
  };

  componentDidMount() {
    const {
      context: {
        UpdateParentWithBucket,
        experiments,
        environment,
        onWhenComponentMount: onMountDefault
      } = {}
    } = this;
    const { bucket, onMount: onMountOverride } = this.props;
    // eslint-disable-next-line no-underscore-dangle
    const parentName = getParentNode(this._reactInternalFiber);

    if (!parentName && environment !== 'production') {
      // eslint-disable-next-line no-console
      console.error(`Could not find a parent for ${bucket}`);
    }

    if (parentName) {
      const doesBucketExistInExperiment = experiments[
        parentName
      ]?.buckets?.find(x => x === bucket);

      if (!doesBucketExistInExperiment) {
        UpdateParentWithBucket({
          experimentName: parentName,
          bucketName: bucket
        });
      }

      this.setState({ parent: parentName });
    }

    const onMount = onMountDefault || onMountOverride;
    if (onMount) onMount({ experimentName: parentName, bucketName: bucket });
  }

  render() {
    const { context: { experiments } = {} } = this;
    const { children, bucket, assignedBucketFunc } = this.props;
    const { parent } = this.state;
    const { assignedBucket, isLoading } = experiments[parent] || {};
    const hasParent = !!parent;
    const isAssignedBucket = assignedBucketFunc
      ? assignedBucketFunc(bucket, assignedBucket)
      : !!(Array.isArray(bucket)
          ? bucket.find(x => x === assignedBucket)
          : assignedBucket === bucket);

    return (
      <Fragment>
        {hasParent && isAssignedBucket && !isLoading && (
          <Fragment>
            {typeof children === 'function'
              ? children({ ...(experiments[parent] || {}) })
              : children}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
